export const STARTUP_RECOVERY_KEY = 'towerarena.com.startup-recovery';

export type StartupRecoveryMode = 'live' | 'replay';

type SessionStoragePort = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

export function isDynamicImportFailure(error: unknown): boolean {
  const message = String(error);
  return message.includes('Failed to fetch dynamically imported module')
    || message.includes('Importing a module script failed')
    || message.includes('error loading dynamically imported module');
}

export function scheduleStartupReload(storage: SessionStoragePort, error: unknown, mode: StartupRecoveryMode): boolean {
  if (!isDynamicImportFailure(error)) return false;
  try {
    if (storage.getItem(STARTUP_RECOVERY_KEY) !== null) return false;
    storage.setItem(STARTUP_RECOVERY_KEY, `pending:${mode}`);
    return true;
  } catch {
    return false;
  }
}

export function consumeStartupRetry(storage: SessionStoragePort): StartupRecoveryMode | null {
  try {
    const value = storage.getItem(STARTUP_RECOVERY_KEY);
    if (value !== 'pending:live' && value !== 'pending:replay') return null;
    storage.setItem(STARTUP_RECOVERY_KEY, `attempted:${value.slice('pending:'.length)}`);
    return value.slice('pending:'.length) as StartupRecoveryMode;
  } catch {
    return null;
  }
}

export function clearStartupRecovery(storage: SessionStoragePort): void {
  try { storage.removeItem(STARTUP_RECOVERY_KEY); }
  catch { /* Startup must remain usable when sessionStorage is unavailable. */ }
}
